import {
  useComercialInvoicingColumns,
  ComercialInvoicingColumns,
} from "./columns";
import { useSelector } from "react-redux";

import { clientSelector } from "@/redux/clients/clients.selector";
import DataTableComercialInvoicing from "./data-table";
import { FacturaComercial } from "@/redux/clients/types/Clients.interface";
import { TableSkeleton } from "@/components/ui/loading";

const FoldersTable = () => {
  const { folderData, loading } = useSelector(clientSelector).ui;

  const columnsComercialInvoicing = useComercialInvoicingColumns();

  const dataFolders =
    (folderData &&
      folderData.carpetas.length > 0 &&
      folderData.carpetas[0].facturasComerciales.map(
        (factura: FacturaComercial) => ({
          numero: factura.nroFactura,
          fecha: factura.fechaFactura,
          condicionVenta: factura.condicionVenta,
          nroInterno: factura.nroInternoRade,
        }),
      )) ||
    [];

  return (
    <div className="container mx-auto pb-2 mt-2 min-w-full">
      {loading ? (
        <TableSkeleton rows={6} columns={4} />
      ) : (
        <DataTableComercialInvoicing
          columns={columnsComercialInvoicing}
          data={dataFolders as ComercialInvoicingColumns[]}
        />
      )}
    </div>
  );
};

export default FoldersTable;
